module.exports = __webpack_public_path__ + "product-bg.jpg?92a435687c3de1b27b10b2fb0f10fd42";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-bg.jpg
// module id = 100
// module chunks = 0